import { crc32AuthCode } from './crcAlgorithms'

export class Crc32AuthAuthenticator {
  generate(params: { key: readonly number[]; data: number[] }): number[] {
    return crc32AuthCode(params)
  }

  verify(params: {
    key: readonly number[]
    data: number[]
    authCode: number[]
  }): boolean {
    const expected = this.generate({ key: params.key, data: params.data })
    if (expected.length !== params.authCode.length) return false
    for (let i = 0; i < expected.length; i++) {
      if (expected[i] !== params.authCode[i]) return false
    }
    return true
  }
}
